import { render, staticRenderFns } from "./Curated.vue?vue&type=template&id=29af5518&"
import script from "./Curated.vue?vue&type=script&lang=js&"
export * from "./Curated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports